import { AnalyticsProps } from '@inplayer-org/inplayer-ui';

interface SeasonField extends AnalyticsProps {
  name: string;
  title: string;
  tooltipContent: string;
  placeholder?: string;
  canBeEdited?: boolean;
  dropdownTag?: string;
  tooltipTag?: string;
}

export const seasonAccessDateFields: Array<SeasonField> = [
  {
    name: 'startsAt',
    title: 'Season start',
    tooltipContent: 'Date and time when the season will start.',
  },
  {
    name: 'expiresAt',
    title: 'Season end',
    tooltipContent: 'Date and time when the season will end.',
  },
  {
    name: 'anchorDate',
    title: 'Next rebill date',
    tooltipContent: ' Date and time for the next rebill of the season subscription.',
  },
];

export const seasonPriceFields: Array<SeasonField> = [
  {
    name: 'seasonPrice',
    placeholder: 'Amount',
    title: 'Next rebill price',
    tooltipContent: `The price customers will pay upon the next rebill.`,
    tooltipTag: 'tooltip_next_rebill_price',
    tag: 'text_next_rebill_amount',
    dropdownTag: 'dropdown_next_rebill_currency',
  },
  {
    name: 'currentPrice',
    placeholder: 'Amount',
    title: 'Current price',
    tooltipContent: `The price customers will pay for the current season, if they subscribe right now.\n This is not the price they will pay upon their next rebill.`,
    tooltipTag: 'tooltip_current_rebill_price',
    canBeEdited: true,
    tag: 'text_current_amount',
    dropdownTag: 'dropdown_current_currency',
  },
];

export const seasonInvalidDatesMessage = 'Please check if the dates are valid.';
